<template>
<div class="work" id="work-8">
	<h2><span>01</span> Orbyt X Business</h2>
	<div class="subtitle">
		<h3><span>Year</span>2025</h3>
		<h3><span>Product</span>Website</h3>
		<h3><span>Technology</span>Wordpress / Figma</h3>
	</div>
	<blockquote>
		Orbyt X Business it's a new innovative company providing consultancy in finance and events making use of AI and new management methodologies.
	</blockquote>
	<figure class="int">
		<figcaption>
			<h3>Objective for this project</h3>
			<p>Create the experience of the website integrating the finance management with events management, two different topics, usually unrelated, to have a seemingly connection.</p>
			<h3>My Role</h3>
			<p>The website visual guideline, page content and structure, pages design, imagery and front-end wordpress development</p>
		</figcaption>
		<span><img src="../../assets/OrbytX-Home-02.jpg" alt="Orbyt X home"></span>
		<span><img src="../../assets/OrbytX-Home-01.jpg" alt="Orbyt X home intermission"></span>
	</figure>
	<figure class="half">
		<figcaption>
			<h3>The Solution</h3>
			<p>Stakeholders wanted the visuals to look elegant and formal, but not too conservative, as the events are both financial and fun.</p>
			<p>Strong imagery, AI-generated, played a key role in linking the two subjects, making the experience memorable for both, and establishing the necessary connection.</p>
		</figcaption>
		<img src="../../assets/OrbytX-mb-00.jpg" alt="Orbyt X mobile home">
		<img src="../../assets/OrbytX-mb-01.jpg" alt="Orbyt X mobile services">
	</figure>
	<figure class="half">
		<figcaption>
			<blockquote>Creating a relevant experience to attract new customers and help them understand the connection between Events and Consulting was definitely a great challenge.</blockquote> 
		</figcaption>
	</figure>
	<figure>
		<span><img src="../../assets/OrbytX-GestãoFinanceira00.jpg" alt="Orbyt X serviços"></span>
		<span><img src="../../assets/OrbytX-GestãoFinanceira01.jpg" alt="Orbyt X serviços 2"></span>
	</figure>
	<blockquote>
		"I'm very happy with the design result, the client was satisfied and the project was high rated. The website will be soon get to be accessed at <a href="//orbytx.com.br" target="_blank">orbytx.com.br</a> in October 2025."
	</blockquote>
</div>
</template>